import { alpha, Theme } from '@mui/material';

export default {
    tagSection: {
        py: 0.25,
        borderBottom: ' 1px solid',
        borderColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.08),
    },
    tagIcon: {
        mr: 1,
        verticalAlign: 'middle',
        fontSize: '16px',
    },
    tagsItemsHolder: {
        ml: -0.25,
        mt: -0.5,
        display: 'flex',
        flexWrap: 'wrap',
    },
    tagLabel: {
        ml: 0.25,
        mt: 0.5,
        fontWeight: 600,
        pr: 1.75,
        display: 'inline-flex',
        lineHeight: '20px',
    },
    tagItem: {
        ml: 0.25,
        mt: 0.5,
        lineHeight: '20px',
        fontSize: '12px',
        borderRadius: '3px',
    },
    termSection: {
        flexDirection: 'column',
        borderBottom: ' 1px solid',
        borderColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.08),
        py: 0.25,

        '.term-section__header': {
            fontWeight: 600,
        },
        '.term-section__items': {
            ml: -0.25,
            pl: '16px',
            width: '100%',
            gap: '2px',
        },
        '&.expand': {
            '.term-section__header': {
                display: 'flex',
                alignItems: 'start',
            },
            '& .term-section__items': {},
        },
        '&.collapse': {
            '.term-section__header': {
                display: 'flex',
                alignItems: 'start',
                '.summary--default &': {
                    color: (theme: Theme) => alpha(theme.palette.text.primary, 0.8),
                },
            },
        },
    },
    iconHolder: {
        height: '16px',
        minWidth: '16px',
        mr: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        marginTop: '2px',
        fontWeight: '400',
    },
};
